<template>
  <div class="wrap">
    <!-- browser-suggestion -->
    <browser-suggestion></browser-suggestion>
    <!-- browser-suggestion -->

    <!-- wrapper  -->
    <div class="wrapper">
      <!-- banner-type -->
      <div :class="[rlstypeImgClass, 'banner-type']"></div>
      <!-- banner-type -->

      <div class="wrap-content">
        <div class="page-title">
          <div class="title">
            <a>招聘公告</a>
          </div>
        </div>

        <!-- 内容区域 -->
        <div class="page-body">
          <!-- let-tab-nav -->
          <div class="let-tab-nav">
            <div class="post-title">职位招聘</div>
            <div class="menu">
              <el-menu
                default-active="1"
                :default-openeds="openeds"
                class="el-menu-vertical-demo"
                v-for="(item, index) in post"
                :key="index"
              >
                <el-submenu :title="item.corp" :index="item.oid + ''">
                  <template slot="title">
                    <span>{{ item.corp }}</span>
                  </template>
                  <el-menu-item-group
                    v-for="(items, indexs) in item.children"
                    :key="indexs"
                  >
                    <el-submenu :title="items.dept" :index="items.deptid + ''">
                      <template slot="title">
                        <span>{{ items.dept }}</span>
                      </template>
                      <el-menu-item-group
                        v-for="(itemss, indexss) in items.children"
                        :key="indexss"
                      >
                        <el-menu-item
                          @click="
                            menuClick(itemss.postid, itemss.posts, item.corp)
                          "
                          :title="itemss.posts"
                          :index="itemss.postid + ''"
                        >
                          <span
                            style="
                              width: 190px;
                              text-overflow: ellipsis;
                              display: inline-block;
                              overflow: hidden;
                              white-space: nowrap;
                            "
                          >
                            {{ itemss.posts }}
                          </span>
                        </el-menu-item>
                      </el-menu-item-group>
                    </el-submenu>
                  </el-menu-item-group>
                </el-submenu>
              </el-menu>
            </div>
          </div>
          <!-- let-tab-nav /-->

          <!-- right-content -->
          <div class="right-content">
            <!-- 标题区域 -->
            <div class="title-wrap">
              <div class="main-title">{{ titleInfo.title }}</div>
              <div class="sub-title">
                <span>来源：</span><span>{{ titleInfo.source }}</span>
                <span> 发布日期：</span><span>{{ titleInfo.rlsdate }}</span>

                <!-- <span>分享到：</span>
                <ul class="share" >
                   <li class="qq"></li>
                </ul> -->
              </div>
            </div>

            <!-- 内容区域 -->
            <p
              class="right-html-content"
              style="line-height: 28px; margin-right: 20px"
              v-html="postContent"
            ></p>

            <!-- 附件区域 -->
            <div class="right-accessory" v-show="accessorys.length > 0">
              <div class="foot-title"><span>附件</span></div>
              <ul class="body">
                <li
                  v-for="item in accessorys"
                  v-bind:key="item.oid"
                  @click="downloadFile(item.oid)"
                >
                  <a>{{ item.filename }}</a> <span>{{ item.filesize }}</span>
                </li>
              </ul>
            </div>

            <!-- 附加岗位层级 -->
            <div class="post-content" v-show="post.length > 0">
              <div class="post-title">
                <span>职位招聘</span>
              </div>
              <div class="menu">
                <el-menu
                  default-active="1"
                  :default-openeds="openeds"
                  class="el-menu-vertical-demo"
                  v-for="(item, index) in post"
                  :key="index"
                >
                  <el-submenu :index="item.oid + ''">
                    <template slot="title">
                      <span>{{ item.corp }}</span>
                    </template>
                    <el-menu-item-group
                      v-for="(items, indexs) in item.children"
                      :key="indexs"
                    >
                      <el-submenu :index="items.deptid + ''">
                        <template slot="title">
                          <span>{{ items.dept }}</span>
                        </template>
                        <el-menu-item-group
                          v-for="(itemss, indexss) in items.children"
                          :key="indexss"
                        >
                          <el-menu-item
                            @click="
                              menuClick(itemss.postid, itemss.posts, item.corp)
                            "
                            :index="itemss.postid + ''"
                          >
                            <span
                              style="
                                max-width: 190px;
                                text-overflow: ellipsis;
                                display: inline-block;
                                overflow: hidden;
                                white-space: nowrap;
                              "
                            >
                              {{ itemss.posts }}
                            </span>
                          </el-menu-item>
                        </el-menu-item-group>
                      </el-submenu>
                    </el-menu-item-group>
                  </el-submenu>
                </el-menu>
              </div>
            </div>
          </div>
          <!-- right-content /-->
        </div>
      </div>
    </div>
    <!-- /wrapper  -->
  </div>
</template>

<script>
import { recruiData, downfile } from "../../request/api";
// import img1 from "../../../assets/image/banner/recrui/1煤炭.jpg";
// import img2 from "../../../assets/image/banner/recrui/2电力.jpg";
// import img3 from "../../../assets/image/banner/recrui/3化工.jpg";
// import img4 from "../../../assets/image/banner/recrui/4物流.jpg";
// import img5 from "../../../assets/image/banner/recrui/5新能源.jpg";
// import img6 from "../../../assets/image/banner/recrui/6通用图.png";
// import img7 from "../../../assets/image/banner/recrui/7校园招聘.jpg";
// import rlstypeDefaultImg from '../../../assets/image/b1.png';
// import { mapMutations } from "vuex";

export default {
  name: "recruitList",
  data() {
    return {
      postContent: "",
      titleInfo: {
        notice: "",
        rlsdate: "",
        rlstype: "",
        source: "",
        title: "",
      },
      openeds: ["1"],
      post: [],
      // 附件
      accessorys: [],
      rlstypeImgClass: "",
      // 煤炭、电力、化工、物流贸易、新能源、通用类、校园招聘
      rlstypeObj: {
        煤炭: "img1",
        电力: "img2",
        化工: "img3",
        物流贸易: "img4",
        新能源: "img5",
        通用图: "img6",
        校园招聘: "img7",
      },
    };
  },
  methods: {
    // ...mapMutations([
    //   // 全局职业选择
    //   "setResumeSelectData",
    // ]),
    initData(oid) {
      recruiData(oid).then((response) => {
        if (response.code == "1") {
          this.postContent = response.data.announcement.content;
          // 标题赋值
          this.titleInfo = {
            notice: response.data.announcement.notice || "",
            rlsdate: response.data.announcement.rlsdate || "",
            rlstype: response.data.announcement.rlstype || "",
            source: response.data.announcement.source || "",
            title: response.data.announcement.title || "",
          };
          // 附件
          this.accessorys = response.data.accessory;

          this.margeNav(response.data.post);

          // 设置图片
          this.rlstypeImgClass =
            this.rlstypeObj[response.data.announcement.rlstype] || "";
        }
      });
    },
    //处理导航数据
    margeNav(list) {
      this.post = this.getMenu(list, []);
    },
    getMenu(arr, menus) {
      let i = -1;
      // 根据单位分级
      arr.filter((item) => {
        let items = menus.find((v) => v.corp == item.corp);

        if (!items) {
          menus.push({
            oid: item.oid,
            corp: item.corp,
            children: [
              {
                deptid: item.deptid,
                dept: item.dept,
                children: [
                  {
                    postid: item.postid,
                    posts: item.posts,
                  },
                ],
              },
            ],
          });
          i = i + 1;
        } else {
          let itemss = menus[i].children.find((v) => v.dept == item.dept);

          if (!itemss) {
            menus[i].children.push({
              deptid: item.deptid,
              dept: item.dept,
              children: [
                {
                  postid: item.postid,
                  posts: item.posts,
                },
              ],
            });
          } else {
            itemss.children.push({
              postid: item.postid,
              posts: item.posts,
            });
          }
        }
      });
      return menus; //导出
    },
    menuClick(postoid, postname, orgname) {
      // // 设置选择的数据
      // // 设置选中数据
      // this.setResumeSelectData({
      //   oid: postoid,
      //   postoid,
      //   postname,
      //   orgname,
      // });
      // this.$router.push(
      //   `/postList?oid=${postoid}&postoid=${postoid}&orgname=${orgname}&postname=${postname}`
      // );
      this.$router.push(
        `/postList?id=${this.$route.query.id}&oid=${postoid}`
      );
    },
    downloadFile(oid) {
      // 下载文件
      this.accessorys.forEach((item) => {
        if (item.oid == oid) {
          var params = {
            isWeb: "true",
            isYES2: "true",
            mode: "1",
            oid: item["oid"],
            service: "DownloadAttachment",
            path: item["filepath"],
            formKey: item["formKey"],
          };
          downfile(params).then((res) => {
            if (res) {
              const url = window.URL.createObjectURL(res);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", item["filename"]);
              document.body.appendChild(link);
              link.click();
            }
          });
        }
      });
    },
  },
  mounted() {
    this.initData(this.$route.query.id);
    window.document.title = this.titleInfo.title;
    if (this.$route.query.stitle) {
      window.document.title = this.$route.query.stitle;
    }
  },
};
</script>

<style lang="scss" scoped>
// banner-type
.wrap {
  .wrapper {
    width: auto;
    margin: 0 auto;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 20px;
    padding-bottom: 40px;
  }

  // banner-type
  .banner-type {
    height: 80px;
    min-height: 80px;
    margin: 0 auto;
    margin-bottom: 12px;

    background-image: url("../../../assets/image/banner/recrui/通用图x480.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;

    &.img1 {
      background-image: url("../../../assets/image/banner/recrui/1煤炭.jpg");
    }
    &.img2 {
      background-image: url("../../../assets/image/banner/recrui/2电力.jpg");
    }
    &.img3 {
      background-image: url("../../../assets/image/banner/recrui/3化工.jpg");
    }
    &.img4 {
      background-image: url("../../../assets/image/banner/recrui/4物流.jpg");
    }
    &.img5 {
      background-image: url("../../../assets/image/banner/recrui/5新能源.jpg");
    }
    &.img6 {
    }
    &.img7 {
      background-image: url("../../../assets/image/banner/recrui/7校园招聘.jpg");
    }
  }

  // banner-type

  .wrap-content {
    margin: 0 auto;

    .page-title {
      background: #fff;
      line-height: 48px;
      // border: 1px solid #e6e6e6;
      margin-bottom: 12px;
      // border-radius: 4px;
      // padding-bottom: 40px;

      .title a {
        margin-left: 16px;
        position: relative;
      }

      .title a::after {
        position: absolute;
        top: 0;
        left: -8px;
        bottom: 0;
        content: "";
        width: 4px;
        background: #0089d0;
      }
    }

    .page-body {
      display: flex;
    }

    .let-tab-nav {
      display: none;
      width: 246px;
      border: 1px solid #f5f5f5;
      flex: 0 0 auto;
      background: #fff;

      .post-title {
        width: 100%;
        height: 40px;
        line-height: 40px;
        background-color: #01539f;
        color: #ffffff;
        font-size: 14px;
        padding-left: 12px;
        box-sizing: border-box;
      }

      .menu {
        .el-menu-vertical-demo {
          ::v-deep .el-submenu__title span {
            width: 190px;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }

      ::v-deep {
        .el-menu {
          border-right: none;
        }
      }
    }

    .right-content {
      flex: auto;
      // margin-left: 12px;
      background: #fff;
      padding: 12px;
      min-height: 150px;

      .right-html-content {
        text-indent: 24px;
      }
    }

    .title-wrap {
      .main-title {
        font-size: 24px;
        text-align: center;
        overflow-wrap: break-word;
        margin-bottom: 12px;
        font-weight: bold;
      }

      .sub-title {
        line-height: 1.5;
        font-size: 14px;
        text-align: center;
        overflow-wrap: break-word;
      }

      .share {
        display: inline-block;
        vertical-align: middle;
        height: 32px;
        li {
          height: 24px;
          width: 24px;
          cursor: pointer;

          &.qq {
            background: url("../../icons/share/QQ.png");
            background-size: 100%;
          }

          &:hover {
            opacity: 0.8;
          }

          &:active {
            opacity: 0.5;
          }
        }
      }
    }

    .right-accessory {
      .foot-title {
        height: 40px;
        line-height: 40px;
        font-size: 18px;
        span {
          padding-left: 12px;
          border-left: 4px solid#23a6de;
        }
      }

      .body {
        list-style: none;
        display: block;

        li {
          display: block;
          cursor: pointer;
          margin-bottom: 12px;

          a {
            display: inline-block;
            font-size: 14px;
            padding: 12px;
            color: #01539f;
            vertical-align: baseline;
          }

          span {
            font-size: 12px;
            display: inline-block;
            vertical-align: baseline;
          }
        }

        li:hover {
          background: #eee;
        }

        li:active {
          opacity: 0.5;
        }
      }
    }

    // post-content
    .post-content {
      .post-title {
        height: 40px;
        line-height: 40px;

        span {
          line-height: 36px;
          font-size: 18px;
          position: relative;
          margin-left: 12px;

          &::after {
            position: absolute;
            top: 0;
            bottom: 0;
            left: -12px;
            content: "";
            background: #23a6de;
            width: 4px;
          }
        }
      }

      .el-menu {
        border-right: none;
        padding: 5px;
        background: #ffffff;
      }

      .posts-item {
        // color: #01539f;
      }

      // #F0F0F0 部门  #F5F5F5 岗位
      // #D2E9FF 部门  #ECF5FF 岗位

      ::v-deep {
        .el-submenu__title {
          // background: #ecf5ff;
          background: #edf1f7;
          // font-size: 16px;
          font-weight: bold;
          // color: #0089D0;
          // color: #01539f;
        }

        .el-menu-item {
          // background: #ecf5ff;
          background: #edf1f7;
          color: #01539f;
        }
      }
    }

    // post-content
  }
}

//

@media screen and (min-width: 320px) {
  .wrap {
    .wrapper {
      width: auto;
      margin: 0 auto;
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 20px;
      padding-bottom: 40px;
    }
    .wrap-content {
      .let-tab-nav {
      }
    }
  }
}

@media screen and (min-width: 480px) {
}
/* 移动 */
@media screen and (min-width: 576px) {
  .wrap {
    // banner-type
    .banner-type {
      height: 154px;

      background-image: url("../../../assets/image/banner/recrui/通用图x720.jpg");
    }
    // banner-type
  }
}
/* 平板 */
@media screen and (min-width: 768px) {
  .wrap {
    // banner-type
    .banner-type {
      height: 128px;
    }
    // banner-type

    .wrap-content {
      .let-tab-nav {
        display: block;
      }

      .right-content {
        margin-left: 12px;
      }
    }

    // post-content
    .post-content {
      display: none;
    }
  }
}

/* PC */
@media screen and (min-width: 992px) {
  .wrap {
    // banner-type
    .banner-type {
      height: 260px;

      background-image: url("../../../assets/image/banner/recrui/通用图x1920.jpg");
    }
    // banner-type
  }
}
@media screen and (min-width: 1200px) {
  .wrap {
    .wrapper {
      padding-left: 0;
      padding-right: 0;
    }

    // banner-type
    .banner-type {
      height: 320px;
      margin-left: 24px;
      margin-right: 24px;
    }
    // banner-type

    .wrap-content {
      width: 1200px;
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>
